

// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { ThemeProvider } from 'styled-components';
// import styled from 'styled-components';
// import { GlobalStyles } from './components/styles/GlobalStyles';
// import { theme } from './components/styles/theme';
// import DropdownNav from './components/Navigation/DropdownNav';
// import Footer from './components/Footer';
// import Home from './pages/Home';
// import PreciousGems from './pages/PreciousGems/PreciousGems';
// import FineGems from './pages/FineGems/FineGems';
// import Tourmaline from './pages/Tourmaline/Tourmaline';
// import Garnets from './pages/Garnets/Garnets';
// import ViewAll from './pages/ViewAll/ViewAll';
// import GemstoneDetail from './pages/GemstoneDetail/GemstoneDetail';
// import LoginModal from './components/Auth/LoginModal';
// import SignupModal from './components/Auth/SignupModal';
// import ProfileDropdown from './components/Auth/ProfileDropdown';
// import AccountSettings from './components/Auth/AccountSettings';
// import { verifyAuth } from './services/api';

// // Styled components for top bar
// const TopBar = styled.div`
//   background: linear-gradient(135deg, #1a2a3a 0%, #2c3e50 100%);
//   padding: 8px 40px;
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
//   gap: 20px;
//   box-shadow: 0 2px 10px rgba(0,0,0,0.1);
// `;

// const LoginButton = styled.button`
//   background: transparent;
//   border: 1.5px solid #c4a484;
//   color: #c4a484;
//   padding: 8px 28px;
//   border-radius: 40px;
//   cursor: pointer;
//   font-size: 14px;
//   font-weight: 500;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background: #c4a484;
//     color: white;
//     transform: translateY(-2px);
//   }
// `;

// const SignupButton = styled.button`
//   background: #c4a484;
//   border: none;
//   color: white;
//   padding: 8px 28px;
//   border-radius: 40px;
//   cursor: pointer;
//   font-size: 14px;
//   font-weight: 500;
//   transition: all 0.3s ease;
  
//   &:hover {
//     background: #b89474;
//     transform: translateY(-2px);
//     box-shadow: 0 4px 12px rgba(196, 164, 132, 0.3);
//   }
// `;

// const ButtonGroup = styled.div`
//   display: flex;
//   gap: 15px;
// `;

// // Main App Layout with Navigation
// const AppLayout = ({ children, isAuthenticated, user, onLogout, onOpenLogin, onOpenSignup }) => {
//   const [showSettings, setShowSettings] = useState(false);
//   const [currentUser, setCurrentUser] = useState(user);

//   const handleUpdateUser = (updatedUser) => {
//     setCurrentUser(updatedUser);
//     localStorage.setItem('user', JSON.stringify(updatedUser));
//   };

//   return (
//     <>
//       {/* TOP BAR WITH PROFILE */}
//       <TopBar>
//         {isAuthenticated && currentUser ? (
//           <ProfileDropdown 
//             user={currentUser} 
//             onLogout={onLogout}
//             onOpenSettings={() => setShowSettings(true)}
//           />
//         ) : (
//           <ButtonGroup>
//             <LoginButton onClick={onOpenLogin}>Login</LoginButton>
//             <SignupButton onClick={onOpenSignup}>Sign Up</SignupButton>
//           </ButtonGroup>
//         )}
//       </TopBar>

//       {/* MAIN NAVIGATION */}
//       <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: 'white' }}>
//         <DropdownNav />
//       </div>

//       {/* PAGE CONTENT */}
//       {children}

//       {/* FOOTER */}
//       <Footer />

//       {/* SETTINGS MODAL */}
//       {showSettings && currentUser && (
//         <AccountSettings 
//           user={currentUser}
//           onClose={() => setShowSettings(false)}
//           onUpdate={handleUpdateUser}
//         />
//       )}
//     </>
//   );
// };

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showLogin, setShowLogin] = useState(false);
//   const [showSignup, setShowSignup] = useState(false);

//   useEffect(() => {
//     const checkAuth = async () => {
//       try {
//         const response = await verifyAuth();
//         if (response.authenticated) {
//           setUser(response.user);
//           setIsAuthenticated(true);
//           localStorage.setItem('user', JSON.stringify(response.user));
//         }
//       } catch (error) {
//         console.log('Not authenticated');
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     checkAuth();
//   }, []);

//   const handleLogin = (userData) => {
//     setUser(userData);
//     setIsAuthenticated(true);
//     localStorage.setItem('user', JSON.stringify(userData));
//     setShowLogin(false);
//   };

//   const handleSignup = (userData) => {
//     setUser(userData);
//     setIsAuthenticated(true);
//     localStorage.setItem('user', JSON.stringify(userData));
//     setShowSignup(false);
//   };

//   const handleLogout = async () => {
//     setUser(null);
//     setIsAuthenticated(false);
//     localStorage.removeItem('user');
//   };

//   if (loading) {
//     return (
//       <div style={{ 
//         minHeight: '100vh', 
//         display: 'flex', 
//         alignItems: 'center', 
//         justifyContent: 'center',
//         background: 'white'
//       }}>
//         <div style={{ color: '#1a2a3a', fontSize: '18px' }}>Loading...</div>
//       </div>
//     );
//   }

//   return (
//     <Router>
//       <ThemeProvider theme={theme}>
//         <GlobalStyles />
        
//         <Routes>
//           <Route path="/" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <Home />
//             </AppLayout>
//           } />
//           <Route path="/precious-gems" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <PreciousGems />
//             </AppLayout>
//           } />
//           <Route path="/fine-gems" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <FineGems />
//             </AppLayout>
//           } />
//           <Route path="/tourmaline" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <Tourmaline />
//             </AppLayout>
//           } />
//           <Route path="/garnets" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <Garnets />
//             </AppLayout>
//           } />
//           <Route path="/view-all" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <ViewAll />
//             </AppLayout>
//           } />
//           <Route path="/gem/:gemName" element={
//             <AppLayout 
//               isAuthenticated={isAuthenticated} 
//               user={user}
//               onLogout={handleLogout}
//               onOpenLogin={() => setShowLogin(true)}
//               onOpenSignup={() => setShowSignup(true)}
//             >
//               <GemstoneDetail />
//             </AppLayout>
//           } />
//         </Routes>

//         {showLogin && (
//           <LoginModal 
//             onClose={() => setShowLogin(false)}
//             onLogin={handleLogin}
//             onSwitchToSignup={() => {
//               setShowLogin(false);
//               setShowSignup(true);
//             }}
//           />
//         )}

//         {showSignup && (
//           <SignupModal 
//             onClose={() => setShowSignup(false)}
//             onSignup={handleSignup}
//             onSwitchToLogin={() => {
//               setShowSignup(false);
//               setShowLogin(true);
//             }}
//           />
//         )}
//       </ThemeProvider>
//     </Router>
//   );
// }

// export default App;

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './components/styles/GlobalStyles';
import { theme } from './components/styles/theme';
import DropdownNav from './components/Navigation/DropdownNav';
import Footer from './components/Footer';
import Home from './pages/Home';
import PreciousGems from './pages/PreciousGems/PreciousGems';
import FineGems from './pages/FineGems/FineGems';
import Tourmaline from './pages/Tourmaline/Tourmaline';
import Garnets from './pages/Garnets/Garnets';
import ViewAll from './pages/ViewAll/ViewAll';
import GemstoneDetail from './pages/GemstoneDetail/GemstoneDetail';
import LoginModal from './components/Auth/LoginModal';
import SignupModal from './components/Auth/SignupModal';
import AccountSettings from './components/Auth/AccountSettings';
import { verifyAuth } from './services/api';

// Main App Layout with Navigation
const AppLayout = ({ children, isAuthenticated, user, onLogout, onOpenLogin, onOpenSignup }) => {
  const [showSettings, setShowSettings] = useState(false);
  const [currentUser, setCurrentUser] = useState(user);

  const handleUpdateUser = (updatedUser) => {
    setCurrentUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser));
  };

  return (
    <>
      {/* MAIN NAVIGATION WITH LOGIN/SIGNUP BUTTONS NEXT TO VIEW ALL */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: 'white' }}>
        <DropdownNav 
          isAuthenticated={isAuthenticated}
          user={currentUser}
          onLogout={onLogout}
          onOpenLogin={onOpenLogin}
          onOpenSignup={onOpenSignup}
          onOpenSettings={() => setShowSettings(true)}
        />
      </div>

      {/* PAGE CONTENT */}
      {children}

      {/* FOOTER */}
      <Footer />

      {/* SETTINGS MODAL */}
      {showSettings && currentUser && (
        <AccountSettings 
          user={currentUser}
          onClose={() => setShowSettings(false)}
          onUpdate={handleUpdateUser}
        />
      )}
    </>
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await verifyAuth();
        if (response.authenticated) {
          setUser(response.user);
          setIsAuthenticated(true);
          localStorage.setItem('user', JSON.stringify(response.user));
        }
      } catch (error) {
        console.log('Not authenticated');
      } finally {
        setLoading(false);
      }
    };
    
    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
    setShowLogin(false);
  };

  const handleSignup = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
    setShowSignup(false);
  };

  const handleLogout = async () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
  };

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'white'
      }}>
        <div style={{ color: '#1a2a3a', fontSize: '18px' }}>Loading...</div>
      </div>
    );
  }

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        
        <Routes>
          <Route path="/" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <Home />
            </AppLayout>
          } />
          <Route path="/precious-gems" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <PreciousGems />
            </AppLayout>
          } />
          <Route path="/fine-gems" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <FineGems />
            </AppLayout>
          } />
          <Route path="/tourmaline" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <Tourmaline />
            </AppLayout>
          } />
          <Route path="/garnets" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <Garnets />
            </AppLayout>
          } />
          <Route path="/view-all" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <ViewAll />
            </AppLayout>
          } />
          <Route path="/gem/:gemName" element={
            <AppLayout 
              isAuthenticated={isAuthenticated} 
              user={user}
              onLogout={handleLogout}
              onOpenLogin={() => setShowLogin(true)}
              onOpenSignup={() => setShowSignup(true)}
            >
              <GemstoneDetail />
            </AppLayout>
          } />
        </Routes>

        {showLogin && (
          <LoginModal 
            onClose={() => setShowLogin(false)}
            onLogin={handleLogin}
            onSwitchToSignup={() => {
              setShowLogin(false);
              setShowSignup(true);
            }}
          />
        )}

        {showSignup && (
          <SignupModal 
            onClose={() => setShowSignup(false)}
            onSignup={handleSignup}
            onSwitchToLogin={() => {
              setShowSignup(false);
              setShowLogin(true);
            }}
          />
        )}
      </ThemeProvider>
    </Router>
  );
}

export default App;